import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=0e31e2b0&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e31e2b0",
  null
  
)

export default component.exports